const envVar = window.location.host.split('.')[0] === 'prod-parc-library-sharing-ui';
export const MATERIAL_FILTER = envVar?"App.PARC.LibrarySharingMaterial_prod":"App.PARC.LibrarySharingMaterial_preprod";
export const BOM_PARTS_FILTER = envVar?"App.PARC.LibraySharingParts_prod":"App.PARC.LibraySharingParts_preprod";
export const LABOR_PROCESS_FILTER = envVar?"App.PARC.LibraySharingLaborProcess_prod":"App.PARC.LibraySharingLaborProcess_preprod";
export const MATERIAL_FILTER_EXT = envVar?"EXT.App.PARC.LibrarySharingMaterial_prod":"EXT.App.PARC.LibrarySharingMaterial_preprod";
export const BOM_PARTS_FILTER_EXT = envVar?"EXT.App.PARC.LibraySharingParts_prod":"EXT.App.PARC.LibraySharingParts_preprod";
export const LABOR_PROCESS_FILTER_EXT = envVar?"EXT.App.PARC.LibraySharingLaborProcess_prod":"EXT.App.PARC.LibraySharingLaborProcess_preprod";


// WEBPACK FOOTER //
// ./src/Libs/userGroup.js